{
  "launching": "Signing you in...",
  "changeLanguage": "Change Language",
  "logOut": "Log out",
  "logout": {
    "success": "Signed out"
  },
  "session": {
    "expired": "Your session expired, please sign in again"
  }
}
